import PropTypes from 'prop-types';
import React, { PureComponent, Component } from 'react';

// An "Artboard" reserves space to place an image and other annotations into using absolute positioning
export default class Artboard extends Component {
    render() {
        return (
            <div
                style={{
                    position: 'relative',
                    width: this.props.width + 'px',
                    height: this.props.height + 'px',
                }}
            >
                {this.props.children}
            </div>
        );
    }
}
Artboard.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/DesignPane/Artboard.jsx